import React from 'react';
import PropTypes from 'prop-types';

const IconPowertrainGuideExternalLink = ({ width = 16, height = 16, color = '#1F1F1F' }) =>
    <svg width={width} height={height} viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <path d='M13 13H3V3H7V1H3C1.9 1 1 1.9 1 3V13C1 14.1 1.9 15 3 15H13C14.1 15 15 14.1 15 13V9H13V13Z' fill={color} />
        <path d='M9.00004 1V3H11.59L4.79004 9.79L6.21004 11.21L13 4.41V7H15V1H9.00004Z' fill={color} />
    </svg>;

IconPowertrainGuideExternalLink.propTypes = {
    color: PropTypes.string,
    height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

export default IconPowertrainGuideExternalLink;
